import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';

import { BootsMapPage } from '../pages/boots-map/boots-map';
import { WelcomePage } from '../pages/welcome/welcome';
import { ProductsPage } from '../pages/products/products';
import { ProductsGroupPage } from '../pages/products/products-group';
import { ProductDetailedPage } from '../pages/products/product-detailed';
import { QuestionnairePage } from '../pages/questionnaire/questionnaire';
import { FavouritesPage } from '../pages/favourites/favourites';
import { FavouritesGroupPage } from '../pages/favourites/favourites-group';
import { FavouriteDetailedPage } from '../pages/favourites/favourite-detailed';
import { AskPage } from '../pages/ask/ask';
import { InfoPage } from '../pages/info/info';

import { DataProvider } from '../providers/data';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { SelectSearchableModule } from 'ionic-select-searchable';
import { Geolocation } from '@ionic-native/geolocation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {ShopsModal} from '../modals/shops/shops';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/",  ".json");
} 

@NgModule({
  declarations: [
    MyApp,
    BootsMapPage,
    WelcomePage,
    QuestionnairePage,
    ProductsPage,
    ProductsGroupPage,
    ProductDetailedPage,
    FavouritesPage,
    FavouritesGroupPage,
    FavouriteDetailedPage,
    AskPage,
    InfoPage,
    ShopsModal
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (HttpLoaderFactory),
            deps: [HttpClient]
        }
    }),
    SelectSearchableModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    BootsMapPage,
    WelcomePage,
    QuestionnairePage,
    ProductsPage,
    ProductsGroupPage,
    ProductDetailedPage,
    FavouritesPage,
    FavouritesGroupPage,
    FavouriteDetailedPage,
    AskPage,
    InfoPage,
    ShopsModal
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataProvider,
    Geolocation,
    InAppBrowser
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts